import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppointmentStatus, appointmentStatuses, AppointmentStatuses, closedAppointmentStatuses, ComplaintAppointmentFilters, ComplaintUserType, openedAppointmentStatuses } from '@icc/b2b/shared';
import { ComplaintPartyListItem } from 'libs/b2b/shared/src/lib/models/complaint-party';
import { ComplaintService } from '../complaint.service';
import { _ } from '@icc/shared/helpers';
import { ConfigService } from '@icc/shared';

@Component({
    selector: 'icc-complaint-appointment-filters',
    templateUrl: './complaint-appointment-filters.component.html',
    styleUrls: ['./complaint-appointment-filters.component.scss']
})
export class ComplaintAppointmentFiltersComponent implements OnChanges {
    @Output() showMap = new EventEmitter<boolean>();
    @Input() isShowMap = false;

    dateFrom: Date = null;
    dateTo: Date = null;

    appointmentStatuses = [
        { value: openedAppointmentStatuses.map(el => el.value), label: _('COMPLAINT|Otwarte') },
        { value: closedAppointmentStatuses.map(el => el.value), label: _('COMPLAINT|Zamknięte') },
        { value: appointmentStatuses.map(el => el.value), label: _('INTERFACE|Dowolny') },
        ...appointmentStatuses
    ];
    status: AppointmentStatus | AppointmentStatus[] | null = appointmentStatuses[0].value as AppointmentStatus | AppointmentStatus[];

    assignedUserId = 0;
    userTypeCompanyId = 0;
    filteredContractorsList: ComplaintPartyListItem[] = [];
    filteredContractors: ComplaintPartyListItem[] = [];
    protected _filters: ComplaintAppointmentFilters;

    @Input() workersList: Record<string, string> | null = null;
    @Input() contractorsList: ComplaintPartyListItem[] = [];
    @Input()
    get filters(): ComplaintAppointmentFilters {
        return this._filters;
    }
    set filters(filters: ComplaintAppointmentFilters) {
        this.setFilters(filters);
    }

    @Input() userType: ComplaintUserType;

    @Output() filtersEmmiter = new EventEmitter<{
        filters: ComplaintAppointmentFilters;
        reset: boolean;
    }>();

    constructor(
        private complaintService: ComplaintService,
        private configService: ConfigService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        const hadNoContractors = !this.filteredContractorsList?.length;
        this.filteredContractorsList = this.contractorsList;
        this.filteredContractors = this.getContractorsList();

        if (hadNoContractors && this.filteredContractorsList?.length && this.userTypeCompanyId) {
            const currentValue = this.userTypeCompanyId;
            this.userTypeCompanyId = 0;
            setTimeout(() => {
                this.userTypeCompanyId = currentValue;
            });
        }
    }

    setFilters(filters: ComplaintAppointmentFilters) {
        if (filters) {
            this._filters = filters;
            this.status = filters.status;
            this.dateFrom = filters.dateFrom ? new Date(new Date(filters.dateFrom).getTime() - new Date(filters.dateFrom).getTimezoneOffset() * 60000) : null;
            this.dateTo = filters.dateTo ? new Date(new Date(filters.dateTo).getTime() - new Date(filters.dateTo).getTimezoneOffset() * 60000) : null;
            this.assignedUserId = filters.assignedUserId;
            this.userTypeCompanyId = filters.assignedCompanyId;
        } else {
            this.resetFilters(false);
        }
    }

    handleWorkers(value) {
        this.assignedUserId = !isNaN(+value) ? +value : 0;
    }

    handleContractor(value: number) {
        this.userTypeCompanyId = !isNaN(+value) ? +value : 0;
    }

    onStatusChange(value: AppointmentStatus | AppointmentStatus[] | null) {
        if (typeof value === 'string' && value.includes(',')) {
            this.status = value.split(',') as AppointmentStatus[];
        } else {
            this.status = value;
        }
    }

    emitFilters(reset = false) {
        this.filtersEmmiter.emit({
            filters: {
                status: this.status,
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                assignedUserId: this.assignedUserId,
                assignedCompanyId: this.userTypeCompanyId
            },
            reset,
        });
    }

    resetFilters(emit = true) {
        this.status = this.appointmentStatuses[0].value as AppointmentStatus | AppointmentStatus[];
        this.dateFrom = null;
        this.dateTo = null;
        this.assignedUserId = 0;
        this.userTypeCompanyId = this.configService.user?.user?.ActiveCompany ? +this.configService.user.user.ActiveCompany : 0;
        if (emit) this.emitFilters(true);
    }

    getUserTypeName(type: ComplaintUserType) {
        return this.complaintService.getUserTypeName(type);
    }

    getContractorsList() {
        return this.contractorsList?.filter(
            (contractor) =>
                (this.userType === 'distributor' && contractor.userType === 'authorizedRetailer') ||
                (this.userType === 'manufacturer' &&
                    (contractor.userType === 'distributor' ||
                        contractor.userType === 'authorizedRetailer'))
        );
    }

    onDateFromChange(event: string) {
        this.dateFrom = this.convertToLocalDate(event);
    }

    onDateToChange(event: string) {
        this.dateTo = this.convertToLocalDate(event);
    }

    private convertToLocalDate(dateString: string): Date {
        const date = new Date(dateString);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    }

    onListClick() {
        this.showMap.emit(false);
    }

    onMapClick() {
        this.showMap.emit(true);
    }
}
